import React, { useState, useEffect } from 'react';
import { CreateTableOld as CreateTable } from '../EmployeeTables/EmployeeTable';
// import { CreateButton } from '../../../CommonObjects';

import { EducationAddForm, EducationEditForm } from '../EmployeeFormFld/EducationForm';
//icons
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { Button } from '../../../../common/APICommon';

export function EducationsTab({
  employeePersonalInformationId,
  employeeEducationAttainments,
  setEmployeeEducationAttainments,
  isEditMode
}) {
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editId, setEditId] = useState("");
  useEffect(() => {
    setData(employeeEducationAttainments);
  }, [employeeEducationAttainments]);

  const openForm = () => {
    if (!employeePersonalInformationId) {
      alert("Please finish personal information first")
      return;
    }
    setShowForm(true);
  }
  const closeForm = () => {
    setShowForm(false);
  }
  const closeEditForm = () => {
    setShowEditForm(false);
  }
  const editHandleClick = (_data) => {
    setEditData(_data);
    setShowEditForm(true);
    const index = data.findIndex(item =>
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.level === _data.level &&
      item.schoolName === _data.schoolName &&
      item.address === _data.address &&
      item.course === _data.course &&
      item.honors === _data.honors &&
      item.dateFrom === _data.dateFrom &&
      item.dateTo === _data.dateTo
    );
    setEditId(index);
  };
  const deleteHandleClick = (_data) => {
    const index = data.findIndex(item =>
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.level === _data.level &&
      item.schoolName === _data.schoolName &&
      item.address === _data.address &&
      item.course === _data.course &&
      item.honors === _data.honors &&
      item.dateFrom === _data.dateFrom &&
      item.dateTo === _data.dateTo
    );
    deleteData(index);
  };

  var header = [
    "Level",
    "School Name",
    "Address",
    "Date From",
    "Date To",
    "Course",
    "Honors",
    "",
  ]
  var accessor = [
    "level",
    "schoolName",
    "address",
    "dateFrom",
    "dateTo",
    "course",
    "honors",
    "manage"
  ]
  const addEmployeesEducation = (employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors) => {
    const newData = {
      "employeePersonalInformationId": employeePersonalInformationId,
      "level": level,
      "schoolName": schoolName,
      "address": address,
      "course": course,
      "honors": honors,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "manage": ""
    };

    setData([...data, newData]);
    setEmployeeEducationAttainments([...employeeEducationAttainments, newData]);
    closeForm();
  };
  const updateData = (employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors) => {
    const newData = {
      "employeePersonalInformationId": employeePersonalInformationId,
      "level": level,
      "schoolName": schoolName,
      "address": address,
      "course": course,
      "honors": honors,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "manage": ""
    };

    setData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });
    setEmployeeEducationAttainments(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });

    closeEditForm();
  };
  const deleteData = (index) => {
    setData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
    setEmployeeEducationAttainments(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
  };

  return (
    <div className="educations-tab">
      <div className="educations-tab-top" style={{ display: isEditMode ? "flex" : "none", justifyContent: "start" }}>
        {/* {CreateButton("addEmployee-education-add", "add row", () => openForm(), "ADD", GroupAddIcon)} */}
        <Button
          icon={<GroupAddIcon />}
          name={"ADD"}
          className={"bg-green-500 hover:bg-green-600 text-white mb-2"}
          onClick={openForm}
        />
      </div>
      <div className="educations-tab-body">
        <div className="employeesTab-table container">
          <CreateTable
            dataList={data}
            dataHeader={header}
            dataAccessor={accessor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            isEditMode={isEditMode}
          />
          {data.length > 0 ? (
            <div></div>
          )
            :
            (
              <div> {/*<p>No records to display</p>*/}</div>
            )}
        </div>
      </div>
      <EducationAddForm isOpen={showForm}
        onClose={closeForm}
        employeePersonalInformationId={employeePersonalInformationId}
        addEmployeesEducation={addEmployeesEducation} />
      <EducationEditForm isOpen={showEditForm}
        onClose={closeEditForm}
        editData={editData}
        employeePersonalInformationId={employeePersonalInformationId}
        addEmployeesEducation={updateData} />
    </div>
  )
}